/**
 * Sum buckets into range totals for the comparison table, reusing the SAME aggregation the
 * SMSWiser stats tables use: additive base metrics summed, ratios (ROI, CTRs, EPC…)
 * recomputed from the summed base — never summed directly.
 * For Media Devoted | Created By Ciro Autiero
 */

import { aggregateVoluum } from '@/features/smswiser-campaigns/components/SmswiserCampaignStatsTab/shared/utils/voluum';

import type { SourceTotals, TimeSeriesBucket } from './types';

export function deriveTotals(buckets?: TimeSeriesBucket[]): SourceTotals {
  const list = buckets ?? [];
  const voluum = aggregateVoluum(list.map((b) => ({ voluum: b.voluum })));
  const binom = aggregateVoluum(list.map((b) => ({ voluum: b.binom })));
  let sentCount = 0;
  let amount = 0;
  for (const b of list) {
    sentCount += b.sms.sentCount || 0;
    amount += b.sms.amount || 0;
  }
  return { voluum, binom, ...tresCommasTotals(list), sms: { sentCount, amount } };
}

/**
 * Only a provider=tres-commas series carries the `tresCommas` slot: its totals
 * are summed the same way. Any other series' totals keep exactly dev's keys.
 */
function tresCommasTotals(list: TimeSeriesBucket[]): Pick<SourceTotals, 'tresCommas'> {
  if (!list.some((b) => b.tresCommas)) return {};
  return { tresCommas: aggregateVoluum(list.map((b) => ({ voluum: b.tresCommas }))) };
}
